angular.module('galilai.creator').controller('PostgenEditController', function ($scope, api, $timeout, $rootScope, $interval) {
    let idCounter = 0;

    $scope.state = {
        loading: false,
        progress: 0,
        postId: null,
    };

    $scope.history = []
    $scope.pages = [];
    $scope.currentIndex = 0;

    $scope.messagesMap = {};
    $scope.historyMap = {};
    $scope.messages = [];
    // An object, not a bare string, and that is the whole point. The chat box sits under
    // `ng-if="!isVideoResult() && !isVideoPending()"`, and ng-if creates a child scope:
    // binding ng-model to a primitive makes the first keystroke define the property on the
    // CHILD, where sendMessage() — which runs on this scope — can never see it. It read an
    // empty string and returned on its first line, so the send button did nothing at all.
    // Writing through an object means both scopes mutate the same one.
    $scope.chat = { text: "" };
    $scope.inputMedias = [];

    $scope.isSheetOpen = false;

    $scope.resetState = function () {
        $scope.pages = [];
        $scope.history = [];
        $scope.currentIndex = 0;
        $scope.messagesMap = {};
        $scope.messages = [];
        $scope.chat.text = "";
        $scope.inputMedias = [];
        $scope.historyMap = {};

        $scope.state = {
            loading: false,
            progress: 0,
            postId: null,
        };
    }
    const editingMessages = [
        gettext("postgenedit.editing1"),
        gettext("postgenedit.editing2"),
        gettext("postgenedit.editing3"),
        gettext("postgenedit.editing4"),
        gettext("postgenedit.editing5"),
        gettext("postgenedit.editing6"),
        gettext("postgenedit.editing7"),
        gettext("postgenedit.editing8"),
        gettext("postgenedit.editing9"),
        gettext("postgenedit.editing10"),
    ];

    const editedMessages = [
        gettext("postgenedit.edited1"),
        gettext("postgenedit.edited2"),
        gettext("postgenedit.edited3"),
        gettext("postgenedit.edited4")
    ];

    function getRandomEditingMessage() {
        const index = Math.floor(Math.random() * editingMessages.length);
        return editingMessages[index];
    }

    function getRandomEditedMessage() {
        const index = Math.floor(Math.random() * editedMessages.length);
        return editedMessages[index];
    }

    /**
     * The balance next to the generate button.
     *
     * Empty while the number is unknown rather than showing a zero — a balance that has not
     * loaded yet and a balance of zero mean very different things to somebody about to spend.
     */
    $scope.getCreditsOwned = function () {
        if (typeof $rootScope.creditsBalance != 'number') {
            return '';
        }
        return gettext('postgen.credits_owned').replace('%s', $rootScope.creditsBalance);
    };

    /**
     * "N credits will be used. You have M credits."
     *
     * A bare number in the footer said nothing about which of the two it was, and it was the
     * price — so somebody short on credit read their cost as their balance. Same sentence the
     * creation screen already uses, for the same reason.
     */
    $scope.getCreditsMessage = function () {
        const used = gettext('postgen.credits_used')
            .replace('%s', '<strong>' + $scope.getVideoCredits() + '</strong>');
        if (typeof $rootScope.creditsBalance != 'number') {
            return used;
        }
        const owned = gettext('postgen.credits_owned')
            .replace('%s', '<strong>' + $rootScope.creditsBalance + '</strong>');
        return used + '. ' + owned;
    };

    /**
     * What one change asked of the assistant costs, under the chat box. Each request draws the page
     * again, so it costs the same as generating a page. Without the balance it only states the price;
     * with a balance too small it says so, since sending would only earn an error.
     */
    $scope.getEditCreditsMessage = function () {
        const cost = $rootScope.creditsPerPost;
        if (typeof $rootScope.creditsBalance == 'number' && $rootScope.creditsBalance < cost) {
            return gettext('postgen_edit.credits_short').replace('%s', $rootScope.creditsBalance);
        }
        return gettext('postgen_edit.credits_used').replace('%s', cost);
    };

    $rootScope.$on('postgen.edit', function (event, data) {
        // The editor can be opened long after the app booted, and generations elsewhere may
        // have moved the balance since
        $rootScope.$emit('credits.updated');
        angular.element('#postgen-editor-modal').modal('show');
        $scope.resetState();
        $scope.state.postId = data.postId;
        $scope.state.shouldReloadCalendar = data.isNew;
        $scope.init(data.postId);
    });

    // Hiding the modal does not unmount the <video>, so without this it keeps playing
    // audio behind the page. Bound once, on the element rather than the scope, because
    // the modal outlives every individual post opened in it.
    angular.element('#postgen-editor-modal').on('hidden.bs.modal', function () {
        angular.element('#postgen-editor-modal').find('video').each(function () {
            try {
                this.pause();
                this.currentTime = 0;
            } catch (err) {
                // A detached or not-yet-loaded element is not worth reporting
            }
        });
        $scope.video.playing = false;
    });

    // State of our own player. Does it start muted? No: the audio is part of the result,
    // and the video only plays on a user tap, so the browser does not block the sound.
    $scope.video = { playing: false, muted: false };

    function videoElement() {
        return document.getElementById('postgen-video');
    }

    $scope.togglePlay = function () {
        const element = videoElement();
        if (!element) {
            return;
        }
        if (element.paused) {
            element.muted = $scope.video.muted;
            const played = element.play();
            // Safari returns undefined; Chrome returns a promise that rejects when the
            // browser blocks it. Falling back to muted beats not playing at all.
            if (played && played.catch) {
                played.catch(function () {
                    element.muted = true;
                    $scope.video.muted = true;
                    element.play();
                    $timeout(angular.noop);
                });
            }
            $scope.video.playing = true;
        } else {
            element.pause();
            $scope.video.playing = false;
        }
        // The video may end or be paused by the system controls
        element.onpause = function () {
            $scope.video.playing = false;
            $timeout(angular.noop);
        };
        element.onplay = function () {
            $scope.video.playing = true;
            $timeout(angular.noop);
        };
    };

    $scope.toggleMute = function () {
        const element = videoElement();
        $scope.video.muted = !$scope.video.muted;
        if (element) {
            element.muted = $scope.video.muted;
        }
    };

    function createPage(image) {
        return { id: ++idCounter, image: image };
    }

    // 🔥 monta mensagens a partir das versions
    function buildMessagesFromVersions(page) {
        let messages = [
            { type: 'bot', text: gettext('postgenedit.adjust_prompt') }
        ];

        let history = [];
        let isFirstMedia = true
        if (page.versions && page.versions.length > 0) {

            let hasMultipleMedias = page.versions.filter(v => v.status === 'success' && v.mediaURL).length > 1;
            page.versions.forEach(function (v, index) {
                if (v.inputs && v.inputs.prompt) {
                    messages.push({
                        type: 'user',
                        text: v.inputs.prompt
                    });

                    if (v.status === 'success' && v.mediaURL) {
                        messages.push({
                            type: 'bot',
                            url: v.mediaURL,
                            // An mp4 through <img> renders as a broken thumbnail, which is
                            // what used to make the video takes unshowable in this panel
                            isVideo: (v.inputs && v.inputs.kind === 'video') || /\.mp4($|\?)/i.test(v.mediaURL),
                            undo: !isFirstMedia || hasMultipleMedias,
                            pageId: page.id,
                            id: v.id,
                            text: getRandomEditedMessage()
                        });
                        isFirstMedia = false;
                    } else if (v.status === 'error') {
                        let errorMessage = gettext('error.generic')
                        if (gettext('postgenedit.error_' + v.error)) {
                            errorMessage = gettext('postgenedit.error_' + v.error)
                        }
                        messages.push({
                            type: 'bot',
                            error: v.error,
                            text: errorMessage
                        });
                    }
                }
            });
        }

        return {
            messages,
            history
        }
    }

    function scrollChat() {
        setTimeout(function () {
            var el = document.getElementById('chatScroll');
            if (el) el.scrollTop = el.scrollHeight;
        }, 50);
    }

    function showGenerationError(message) {
        if (message === 'no_credits') {
            $rootScope.$emit('credits.show')
        } else if (message === 'plan_required') {
            // The server refused on plan, not on balance: the paywall to show is the plan one
            $rootScope.showUpgrade('video_generation')
        } else {
            let errorMessage = gettext('error.generic')
            if (gettext('postgenedit.error_' + message)) {
                errorMessage = gettext('postgenedit.error_' + message)
            }
            showError(errorMessage);
        }
    }

    $scope.sendMessage = function () {
        if (!$scope.chat.text || !$scope.chat.text.trim()) return;

        let currentMessage = $scope.chat.text.trim();
        let page = $scope.pages[$scope.currentIndex];
        let pageId = page.id;

        if (!$scope.messagesMap[pageId]) {
            $scope.messagesMap[pageId] = [];
        }

        let pageMessages = $scope.messagesMap[pageId];

        // user message
        pageMessages.push({ type: 'user', text: currentMessage });
        $scope.messages = pageMessages;

        $scope.chat.text = "";

        setTimeout(function () {
            var el = document.getElementById('chatTextarea');
            if (el) el.style.height = "auto";
        });

        scrollChat();

        $scope.state.loading = true;

        // bot loading message
        pageMessages.push({
            type: 'bot',
            text: getRandomEditingMessage(),
            loading: true
        });

        $scope.messages = pageMessages;

        api.editPostContentPage({
            postId: $scope.state.postId,
            pageId: pageId,
            inputs: {
                prompt: currentMessage,
                medias: $scope.inputMedias || [],
            }
        }).then(function (res) {
            if (res?.data?.success) {
                $scope.waitUntilReady(function (result) {
                    $scope.state.loading = false;
                    $timeout(angular.noop);
                    if (result.success) {
                        $scope.inputMedias = [];
                    } else {
                        // Get last version of the page to check for errors
                        let lastVersion = page.versions ? page.versions[page.versions.length - 1] : null;
                        if (lastVersion && lastVersion.status === 'error' && lastVersion.error == 'no_credits') {
                            $rootScope.$emit('credits.show')
                        }
                    }
                });
            }
            else {
                $scope.state.loading = false;
                pageMessages.pop();
                $scope.messages = pageMessages;
                showGenerationError(res?.data?.error);
            }
        }).catch(function (error) {
            pageMessages.pop();
            $scope.messages = pageMessages;

            showGenerationError(error?.data?.error || error.message || error?.error)
            $scope.state.loading = false;
        });
    };

    $scope.handleKey = function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            $scope.sendMessage();
        }
    };

    var mediaQuery = window.matchMedia("(max-width: 767px)");

    function updateDevice() {
        $scope.isMobile = mediaQuery.matches;
    }

    updateDevice();
    mediaQuery.addListener(function () {
        $scope.$apply(updateDevice);
    });

    $scope.shouldCollapseDesktop = function () {
        return $scope.pages.length > 8;
    };

    $scope.init = function () {
        $scope.waitUntilReady();
    };

    $scope.waitUntilReady = function (cb) {
        $scope.state.loading = true;

        function getPost() {
            api.getPostContentByPostId($scope.state.postId).then(function (response) {

                function renderPages(response) {
                    let pagesMap = {};
                    let messagesMap = {}
                    let historyMap = {};
                    if (!response?.data?.postContent?.pages || response.data.postContent.pages.length === 0) {
                        return
                    }
                    response.data.postContent.pages.map(function (p) {

                        let medialURL = null;
                        // The LAST successful one, not the first: after the cover has been
                        // refined a few times the placeholder shown while generating must be
                        // the most recent cover, and that is what becomes the video poster
                        let validMedias = p?.versions ? p.versions.filter(v => v.status === 'success' && v.mediaURL) : [];
                        let lastValidVersion = validMedias.length > 0 ? validMedias[validMedias.length - 1] : null;
                        let lastValidVersionMediaURL = lastValidVersion ? lastValidVersion.mediaURL : null;
                        // Filter out error versions
                        const validVersions = p.versions ? p.versions.filter(v => v.status !== 'error') : [];
                        if (validVersions?.length > 0 && validVersions[validVersions.length - 1].mediaURL) {
                            medialURL = validVersions[validVersions.length - 1].mediaURL + '?t=' + new Date().getTime();
                        } else if (p.versions && p.versions.length > 1 && ['in_progress', 'pending'].indexOf(p.versions[p.versions.length - 1].status) !== -1 && lastValidVersionMediaURL) {
                            medialURL = lastValidVersionMediaURL + '?t=' + new Date().getTime();
                        } else {
                            const mapSizes = {
                                '4:5': '600x750',
                                '9:16': '600x1067',
                                '1:1': '800x800'
                            }
                            let size = mapSizes[response.data.postContent.aspect] || '600x750';
                            medialURL = 'https://placehold.co/' + size + '?text=' + encodeURIComponent(gettext('postgenedit.no_image')) + '&t=png';
                        }

                        // Video state of this page. Everything comes from the last version:
                        // a video post keeps cover versions and the animation side by side
                        // in the same array.
                        let lastVersion = p.versions && p.versions.length > 0
                            ? p.versions[p.versions.length - 1]
                            : null;
                        let lastIsVideo = !!(lastVersion && lastVersion.inputs && lastVersion.inputs.kind === 'video');
                        let videoReady = lastIsVideo && lastVersion.status === 'success' && !!lastVersion.mediaURL;
                        let videoPending = lastIsVideo && ['pending', 'in_progress'].indexOf(lastVersion.status) !== -1;

                        let parsedPage = {
                            id: p.id,
                            image: medialURL,
                            isVideo: videoReady,
                            videoPending: videoPending,
                            // Always a jpg: used as the <video> poster and for thumbnails
                            poster: videoReady
                                ? ((lastVersion.extras && lastVersion.extras.thumb) || null)
                                : medialURL,
                            // The swap to the user's own voice failed: the video came out
                            // with the model's voice, and that has to be said rather than
                            // slip by
                            voiceError: videoReady && lastVersion.extras
                                ? (lastVersion.extras.voiceError || null)
                                : null,
                            // Every attempt is a paid conversion: the button goes away at
                            // the cap
                            voiceRetries: (lastVersion.extras && lastVersion.extras.voiceRetries) || 0,
                            versions: p.versions || []
                        };

                        pagesMap[p.id] = parsedPage;

                        // 🔥 gera mensagens por página
                        let result = buildMessagesFromVersions(p);
                        messagesMap[p.id] = result.messages;
                        historyMap[p.id] = result.history;

                        return parsedPage;
                    });

                    let sortedPages = [];

                    for (let i = 0; i < response.data.postContent.order.length; i++) {
                        let pageId = response.data.postContent.order[i];
                        if (pagesMap[pageId]) {
                            sortedPages.push(pagesMap[pageId]);
                        }
                    }

                    $scope.pages = sortedPages;

                    // Duration and motion picked in the create modal become the defaults of
                    // the animate bar. A plain image post has none of this and keeps the
                    // defaults, which is exactly the "empty motion request" case.
                    let metaInputs = response.data.postContent.meta && response.data.postContent.meta.inputs;
                    if (metaInputs) {
                        if (metaInputs.duration) {
                            $scope.videoSettings.duration = metaInputs.duration;
                        }
                        if (metaInputs.motion) {
                            $scope.videoSettings.motion = metaInputs.motion;
                        }
                    }

                    return {
                        messagesMap,
                        historyMap
                    }
                }
                if ((response?.data?.status === 'success' || response?.data?.status === 'error') && response.data.postContent) {

                    let result = renderPages(response);
                    $scope.messagesMap = result.messagesMap;
                    $scope.historyMap = result.historyMap;

                    // 🔥 atualiza mensagens da página atual
                    if ($scope.pages.length > 0) {
                        let currentPage = $scope.pages[$scope.currentIndex] || $scope.pages[0];
                        $scope.currentIndex = $scope.pages.indexOf(currentPage);
                        $scope.messages = $scope.messagesMap[currentPage.id] || [];
                        $scope.history = $scope.historyMap[currentPage.id] || [];
                    }

                    $timeout(angular.noop);

                    if (cb) cb({
                        success: response.data.status === 'success'
                    });

                    // Every generation that lands here has been charged, so the balance on
                    // screen is stale from this moment. Emitted on error too: a refused or
                    // refunded generation moves the number just as much as a successful one.
                    $rootScope.$emit('credits.updated');

                    $scope.state.loading = false;

                    $timeout(scrollChat, 100);

                    if ($scope.state.shouldReloadCalendar) {
                        $rootScope.$emit('calendarReload');
                        $scope.state.shouldReloadCalendar = false;
                    }
                } else {
                    renderPages(response);
                    $timeout(getPost, 2000);
                }

            }).catch(function (error) {
                if (cb) cb({ success: false, error: error });
                console.error('Error fetching post content:', error);
            });
        }

        getPost();
    };

    $scope.setPageById = function (id) {
        const index = $scope.pages.findIndex(function (p) { return p.id === id; });

        if (index !== -1) {
            $scope.currentIndex = index;

            let page = $scope.pages[index];

            if (!$scope.messagesMap[page.id]) {
                let result = buildMessagesFromVersions(page);
                $scope.messagesMap[page.id] = result.messages;
                $scope.historyMap[page.id] = result.history;
            }

            $scope.messages = $scope.messagesMap[page.id];
            $scope.history = $scope.historyMap[page.id] || [];
        }
        $timeout(scrollChat, 100);
    };

    $scope.setPageFromSheet = function (id) {
        if ($scope.state.loading) return;
        $scope.setPageById(id);
        $scope.closeSheet();
    };

    $scope.openSheet = function () {
        $scope.isSheetOpen = true;
    };

    $scope.closeSheet = function () {
        $scope.isSheetOpen = false;
    };

    $scope.addPage = function () {
        $scope.state.loading = true;

        api.addPostContentPage($scope.state.postId).then(function () {

            $scope.waitUntilReady(function () {
                $scope.currentIndex = $scope.pages.length - 1;

                let page = $scope.pages[$scope.currentIndex];

                $scope.messagesMap[page.id] = [
                    { type: 'bot', text: gettext('postgenedit.adjust_prompt') }
                ];

                $scope.messages = $scope.messagesMap[page.id];
                $scope.history = $scope.historyMap[page.id] || [];
            });

        }).catch(function (error) {
            console.error('Error adding page:', error);
            $scope.state.loading = false;
        });
    };

    $scope.duplicatePage = function () {
        const current = $scope.pages[$scope.currentIndex];
        const copy = createPage(current.image);
        $scope.pages.splice($scope.currentIndex + 1, 0, copy);
        $scope.currentIndex++;
    };

    $scope.removePage = function () {
        showConfirm(gettext('label.are_you_sure'), null, function (status) {
            if (status) {
                $scope.state.loading = true;

                const pageId = $scope.pages[$scope.currentIndex].id;

                api.removePostContentPage($scope.state.postId, pageId).then(function () {

                    $scope.waitUntilReady(function () {
                        if ($scope.currentIndex > $scope.pages.length - 1) {
                            $scope.currentIndex = $scope.pages.length - 1;
                        }

                        $scope.state.loading = false;
                    });

                }).catch(function (error) {
                    console.error('Error removing page:', error);
                    $scope.state.loading = false;
                });
            }
        });
    };

    $scope.isMobileChatOpen = false;

    $scope.openMobileChat = function () {
        $scope.isMobileChatOpen = true;
    };

    $scope.closeMobileChat = function () {
        $scope.isMobileChatOpen = false;
    };

    $scope.schedulePost = function() {
        angular.element('#postgen-editor-modal').modal('hide');
        $rootScope.$emit('fastmode.show', {
            postId: $scope.state.postId,
            pendingPosts: []
        })
    }

    $scope.downloadPost = function() {
        $rootScope.$broadcast('post.download', {
            _id: $scope.state.postId,
            data: {
                // The download controller branches on this for the premium gate and the
                // progress estimate: an mp4 announced as 'post' takes the wrong path
                format: $scope.isVideoResult() ? 'reels' : 'post',
                items: $scope.pages,
            }
        });
    }

    // ---- Video mode ----------------------------------------------------------
    // Three states in the same modal, all derived from the current page's last version:
    //   A) review cover -> canAnimate: cover ready, chat active, animate bar
    //   B) generating   -> isVideoPending: poster + progress, no chat
    //   C) video ready  -> isVideoResult: <video>, download and schedule, no chat

    $scope.videoSettings = {
        duration: 10,
        motion: 'subtle',
        prompt: '',
        // The lookalike whose voice the take will speak with. Only the voice: the cover is
        // already on screen and approved, so the lookalike's photo has no part here.
        avatar: null,
        avatarVoiceOption: null,
        // Carried from the take before it, so a retake of a scripted post stays scripted
        script: null,
        videoMode: null,
        guidelines: '',
        // What to write the next script about. Seeded from the current headline, because on a
        // retake the original brief is not on the version — only what it produced.
        subject: '',
        // Set only by a deliberate pick of the model voice — see clearVideoAvatar
        modelVoice: false,
        writingScript: false,
    };

    function currentPage() {
        return $scope.pages && $scope.pages.length > 0 ? $scope.pages[$scope.currentIndex] : null;
    }

    $scope.isVideoResult = function () {
        const page = currentPage();
        return !!(page && page.isVideo);
    };

    $scope.isVideoPending = function () {
        const page = currentPage();
        return !!(page && page.videoPending);
    };

    /**
     * Progress bar for video generation.
     *
     * It is an estimate, not a measurement: the server reports no progress. It fills in a
     * minute and stops at 100%, where the wait is counted in sentences instead of numbers
     * — inventing an ETA the provider does not give would be worse than giving none.
     */
    const PROGRESS_SECONDS = 60;
    // Quantas frases de espera existem no i18n, ciclando depois que a barra enche
    const WAITING_MESSAGES = 3;
    let progressTimer = null;

    $scope.videoProgress = 0;
    $scope.videoWaitingIndex = 0;

    function stopProgress() {
        if (progressTimer) {
            $interval.cancel(progressTimer);
            progressTimer = null;
        }
    }

    function startProgress() {
        stopProgress();
        $scope.videoProgress = 0;
        $scope.videoWaitingIndex = 0;
        let elapsed = 0;
        progressTimer = $interval(function () {
            elapsed += 1;
            $scope.videoProgress = Math.min(100, Math.round((elapsed / PROGRESS_SECONDS) * 100));
            if ($scope.videoProgress >= 100) {
                // Full: from here on only the sentence changes, every 8 seconds
                $scope.videoWaitingIndex = Math.floor((elapsed - PROGRESS_SECONDS) / 8) % WAITING_MESSAGES;
            }
        }, 1000);
    }

    $scope.$watch($scope.isVideoPending, function (pending) {
        if (pending) {
            if (!progressTimer) {
                startProgress();
            }
        } else {
            stopProgress();
        }
    });

    $scope.$on('$destroy', stopProgress);

    // Whether it failed or not, never why. The reason is a technical decision of ours —
    // queue, configuration, provider quota — and says nothing to somebody who only wanted
    // their own voice in the video. It stays in the version's extras.voiceError, server
    // side.
    $scope.hasVoiceError = function () {
        const page = currentPage();
        return Boolean(page && page.voiceError);
    };

    // Mirrors the server cap (voiceSwap.MAX_RETRIES): offering a button that will be
    // refused is worse than offering none
    const MAX_VOICE_RETRIES = 3;

    $scope.canRetryVoice = function () {
        const page = currentPage();
        return Boolean(page && page.voiceError) && (page.voiceRetries || 0) < MAX_VOICE_RETRIES;
    };

    // Works for any generated post, not only the ones created through the video flow.
    // Carousels are excluded: a half image, half video post has no representation.
    /**
     * Whether a video can be generated from this page — holds both for the first animation
     * and for asking another take of a video that already exists.
     */
    $scope.canGenerateVideo = function () {
        if ($scope.state.loading || $scope.pages.length !== 1) {
            return false;
        }
        if ($scope.isVideoPending()) {
            return false;
        }
        const page = currentPage();
        if (!page || !page.versions) {
            return false;
        }
        // An IMAGE version has to exist: it is what the animation starts from
        return page.versions.some(function (v) {
            return v.status === 'success' && v.mediaURL && v.inputs?.kind !== 'video';
        });
    };

    $scope.getVideoCredits = function () {
        return $rootScope.getVideoCreditsFor($scope.videoSettings.duration || 10);
    };

    $scope.canAffordDuration = function (duration) {
        return $rootScope.canAffordVideoDuration(duration);
    };

    // Empty while the chosen duration fits, so the template can use it as the condition
    $scope.getDurationWarning = function () {
        return $rootScope.getVideoCreditsWarning($scope.videoSettings.duration);
    };

    // The "turn it into a video" bar is an invitation, and only makes sense while there is
    // no video. Once it exists, the invitation is "generate another take".
    $scope.canAnimate = function () {
        return $scope.canGenerateVideo() && !$scope.isVideoResult();
    };

    // Every door into video spending goes through the settings modal, whose confirm button has this gate
    $scope.canAffordAnimation = function () {
        return $scope.canAffordDuration($scope.videoSettings.duration);
    };

    $scope.showVideoSettings = function (generateOnConfirm) {
        $scope.videoSettings.generateOnConfirm = !!generateOnConfirm;
        // The other door into video spending, next to the home cards. Same gate, same
        // reason: no credits spent on something the plan cannot publish.
        if (!$rootScope.isPremiumCustomer()) {
            $rootScope.showUpgrade('video_generation');
            return;
        }
        prefillVideoAvatar();
        prefillVideoScript();
        angular.element('#postgen-video-settings-modal').modal('show');
    };

    $scope.chooseVideoDuration = function (duration) {
        $scope.videoSettings.duration = duration;
    };

    /**
     * Shows which lookalike the take will borrow the voice from.
     *
     * The id is on the version; the name and the photo are not, so the list is fetched once
     * and matched. A failure here only means the row says nothing — it never blocks the
     * modal, and the server inherits the same lookalike whether or not this resolved.
     */
    /**
     * Brings the script lane forward into the dialog.
     *
     * The server inherits the same values on its own, so this is not what makes a retake
     * scripted — it is what lets the user SEE and change the script before paying for it.
     */
    function prefillVideoScript() {
        const page = currentPage();
        if (!page || !page.versions) {
            return;
        }
        for (let i = page.versions.length - 1; i >= 0; i--) {
            const inputs = page.versions[i].inputs;
            if (!inputs) {
                continue;
            }
            if (!$scope.videoSettings.script && inputs.script) {
                // A copy: editing here must not rewrite the version already generated
                $scope.videoSettings.script = JSON.parse(JSON.stringify(inputs.script));
            }
            if (!$scope.videoSettings.videoMode && inputs.videoMode) {
                $scope.videoSettings.videoMode = inputs.videoMode;
            }
            if (!$scope.videoSettings.guidelines && inputs.guidelines) {
                $scope.videoSettings.guidelines = inputs.guidelines;
            }
        }
        if (!$scope.videoSettings.subject && $scope.videoSettings.script) {
            $scope.videoSettings.subject = $scope.videoSettings.script.title || '';
        }
    }

    /**
     * The model voice is a choice, not the absence of one.
     *
     * It needs saying out loud: an absent lookalike means "keep whatever the last take used",
     * which is what stops a retake from silently losing the user's voice. Without this flag,
     * picking the model voice here would be indistinguishable from not having opened the
     * dialog, and the server would put the lookalike back.
     */
    $scope.clearVideoAvatar = function () {
        $scope.videoSettings.avatar = null;
        $scope.videoSettings.avatarVoiceOption = null;
        $scope.videoSettings.modelVoice = true;
    };

    // Free, like on the creation screen: asking for another idea must stay cheap enough that
    // nobody hesitates. Only the video costs credits.
    $scope.regenerateVideoScript = function () {
        if (!$scope.videoSettings.script || $scope.videoSettings.writingScript) {
            return;
        }
        $scope.videoSettings.writingScript = true;
        api.generateVideoScript({
            mode: $scope.videoSettings.videoMode,
            subject: $scope.videoSettings.subject || $scope.videoSettings.script.title,
            duration: $scope.videoSettings.duration,
            guidelines: $scope.videoSettings.guidelines,
            project: $scope.project,
        }).then(function (response) {
            if (response?.data?.success && response.data.script) {
                $scope.videoSettings.script = response.data.script;
                return;
            }
            showError(gettext('postgenvideo.script_error'));
        }).catch(function () {
            showError(gettext('postgenvideo.script_error'));
        }).finally(function () {
            $scope.videoSettings.writingScript = false;
            $timeout(angular.noop);
        });
    };

    function prefillVideoAvatar() {
        if ($scope.videoSettings.avatar) {
            return;
        }
        const page = currentPage();
        if (!page || !page.versions) {
            return;
        }
        let avatarId = null;
        for (let i = page.versions.length - 1; i >= 0 && !avatarId; i--) {
            const inputs = page.versions[i].inputs;
            if (inputs && inputs.avatarId) {
                avatarId = inputs.avatarId;
            }
        }
        if (!avatarId) {
            return;
        }
        api.listAvatars().then(function (response) {
            const all = (response?.data?.mine || []).concat(response?.data?.catalog || []);
            const found = all.find(function (item) { return String(item._id) === String(avatarId); });
            if (found) {
                $scope.videoSettings.avatar = found;
                $timeout(angular.noop);
            }
        }).catch(function () {});
    }

    $scope.chooseVideoAvatar = function () {
        $rootScope.$broadcast('avatar.picker.show', {
            origin: 'postgenedit',
            projectId: $scope.project || null,
        });
    };

    $rootScope.$on('avatar.selected', function (event, data) {
        if (!data || data.origin !== 'postgenedit' || !data.avatar) {
            return;
        }
        $scope.videoSettings.avatar = data.avatar;
        $scope.videoSettings.avatarVoiceOption = data.voiceOption || null;
        $scope.videoSettings.modelVoice = false;
        $timeout(angular.noop);
    });

    $scope.chooseVideoMotion = function (motion) {
        $scope.videoSettings.motion = motion;
    };

    $scope.confirmVideoSettings = function () {
        if (!$scope.canAffordDuration($scope.videoSettings.duration)) {
            return;
        }
        angular.element('#postgen-video-settings-modal').modal('hide');
        // Opened from a "generate" button the modal IS the confirmation; opened from
        // "change settings", it only adjusts.
        if ($scope.videoSettings.generateOnConfirm) {
            $scope.videoSettings.generateOnConfirm = false;
            $scope.animate();
        }
    };

    $scope.animate = function () {
        if (!$scope.canGenerateVideo() || !$scope.canAffordAnimation()) {
            return;
        }
        if (!$rootScope.isPremiumCustomer()) {
            $rootScope.showUpgrade('video_generation');
            return;
        }
        const page = currentPage();
        $scope.state.loading = true;

        api.animatePost({
            postId: $scope.state.postId,
            pageId: page.id,
            duration: $scope.videoSettings.duration,
            motion: $scope.videoSettings.motion,
            prompt: $scope.videoSettings.prompt,
            // Absent means "keep the previous take's": the server reads it off the earlier
            // versions, so the voice survives a retake nobody thought to configure
            avatarId: $scope.videoSettings.avatar ? $scope.videoSettings.avatar._id : null,
            avatarVoiceOption: $scope.videoSettings.avatarVoiceOption,
            useModelVoice: $scope.videoSettings.modelVoice,
            script: $scope.videoSettings.script,
            guidelines: $scope.videoSettings.guidelines,
        }).then(function (response) {
            if (response?.data?.success) {
                $scope.videoSettings.prompt = '';
                $scope.waitUntilReady();
            } else {
                $scope.state.loading = false;
                // Already opens the paywall on no_credits and translates the other codes
                showGenerationError(response?.data?.error);
            }
        }).catch(function (error) {
            console.error('Error animating post:', error);
            $scope.state.loading = false;
            showGenerationError(error?.data?.error || error.message);
        });
    };

    // The retry is free: the video was already paid for and all that is missing is the
    // audio. The most common cause of failure is no voice slot at that instant, which
    // clears on its own.
    // The avatar behind this video was deleted, and its voice sample went with it. Retrying as
    // it stands can never work, so the screen asks for a current avatar instead of offering a
    // button that is guaranteed to fail.
    $scope.needsNewAvatar = function () {
        const page = currentPage();
        return Boolean(page && page.voiceError === 'avatar_gone');
    };

    $scope.chooseVoiceAvatar = function () {
        $rootScope.$broadcast('avatar.picker.show', {
            origin: 'voiceretry',
            projectId: $scope.project || null,
        });
    };

    $rootScope.$on('avatar.selected', function (event, data) {
        if (!data || data.origin !== 'voiceretry' || !data.avatar) {
            return;
        }
        $scope.retryVoice(data.avatar._id || data.avatar.id);
    });

    $scope.retryVoice = function (avatarId) {
        const page = currentPage();
        if (!page || !page.versions || page.versions.length === 0 || $scope.state.voiceRetrying) {
            return;
        }
        const version = page.versions[page.versions.length - 1];
        $scope.state.voiceRetrying = true;

        api.retryVoice({
            postId: $scope.state.postId,
            pageId: page.id,
            versionId: version.id,
            avatarId: avatarId,
        }).then(function (response) {
            $scope.state.voiceRetrying = false;
            if (response?.data?.success) {
                // The same "generating" state as creation: without it the bar disappears
                // and the screen sits still, which is what makes people click again
                startProgress();
                $scope.waitUntilReady();
            } else {
                showGenerationError(response?.data?.error);
            }
        }).catch(function (error) {
            console.error('Error retrying voice:', error);
            $scope.state.voiceRetrying = false;
            showGenerationError(error?.data?.error || error.message);
        });
    };

    // Once it is done the user can ask for another take. Reopening the settings makes
    // the cost visible again before spending.
    $scope.animateAgain = function () {
        $scope.showVideoSettings(true);
    };

    $scope.selectMedia = function() {
        if ($scope.loading) {
            return
        }
        $rootScope.$broadcast('media.show', {
            source: {
                origin: 'postgen.edit',
            },
            projectId: $scope.project,
            kind: 'image',
            openModal: true,
            multiple: true,
        })
    }

    $scope.removeImage = function(index) {
        if ($scope.inputMedias && $scope.inputMedias.length > index) {
            $scope.inputMedias.splice(index, 1);
        }
    }

    $rootScope.$on('media.selected', function(event, medias, source) {
        if (source && source.origin != 'postgen.edit') {
            return
        }

        if (medias && medias.length > 0) {
            // Append to existing medias
            if (!$scope.inputMedias) {
                $scope.inputMedias = [];
            }
            medias = $scope.inputMedias.concat(medias.map(function(media) {
                return {
                    url: media.url
                }
            }))

            let seen = new Set();
            medias = medias.filter(function(media) {
                if (seen.has(media.url)) {
                    return false;
                } else {
                    seen.add(media.url);
                    return true;
                }
            })

            if (medias.length > 3) {
                medias = medias.slice(0, 3)
                showError(gettext('error.max_selected_medias').replace('%s', 3))
            }
            $scope.inputMedias = medias
        }
    })

    $scope.purchaseCredits = function() {
        $rootScope.$emit('credits.show')
    }

    $scope.showInstructionsHelp = function() {
        // Video mode has no chat: pointing at the instructions field would send the user
        // looking for something that is not on screen. There the way to change the result
        // is to generate another take.
        if ($scope.isVideoResult()) {
            showSuccess(gettext('postgenedit.instructions_help_video'))
            return
        }
        if ($scope.isVideoPending()) {
            showSuccess(gettext('postgenedit.instructions_help_generating'))
            return
        }
        showSuccess(gettext('postgenedit.instructions_help'))
    }

    /**
     * The preview inside the "go back to this version" dialog.
     *
     * A video went in through <img>, which draws nothing: the user was asked to confirm
     * discarding takes against a blank rectangle. It plays here, with sound — the audio is
     * half of what tells two takes apart, and the whole point of the dialog is recognising
     * which one this is. `controls` is what gives it the play button; a custom overlay would
     * need JS wired after the dialog injects this string, and a preview that sometimes fails
     * to bind is worse than the browser's own.
     */
    function isVideoVersion(version) {
        return Boolean(version.isVideo
            || (version.inputs && version.inputs.kind === 'video')
            || /\.mp4($|\?)/i.test(version.url || ''));
    }

    function versionPreviewHTML(version) {
        const style = 'display: block; margin: 10px auto 0; max-width: 100%; max-height: 300px; height: auto;';
        const isVideo = isVideoVersion(version);
        if (isVideo) {
            return '<br><video src="' + version.url + '" style="' + style + '" controls playsinline preload="metadata"></video>';
        }
        return '<br> <img src="' + version.url + '" style="' + style + '" />';
    }

    $scope.undoVersion = function(version, isLast) {
        let currentVersion = version;
        if (isLast) {
            console.log('Undoing last version, looking for previous media version if exists');
            let page = $scope.pages.find(p => p.id === version.pageId);

            if (page) {
                let currentIndex = page.versions.findIndex(v => v.id === version.id);

                if (currentIndex > 0) {
                    for (let i = currentIndex - 1; i >= 0; i--) {
                        let v = page.versions[i];

                        if (v.status === 'success' && v.mediaURL) {
                            currentVersion = JSON.parse(JSON.stringify(v));
                            currentVersion.pageId = page.id;
                            currentVersion.url = currentVersion.mediaURL + '?t=' + new Date().getTime();
                            break;
                        }
                    }
                }
            }
        }

        // Going back from a video lands on the cover it was animated from, because that is
        // the only earlier version there is. The preview alone does not say so — a still
        // frame and a cover look identical when the cover is what the video starts on — and
        // what is really being discarded is the video, which was paid for.
        let warning = '';
        if ($scope.isVideoResult() && !isVideoVersion(currentVersion)) {
            warning = '<br><strong>' + gettext('postgenedit.undo_to_cover') + '</strong>';
        }

        showConfirm(gettext('postgenedit.confirm_undo') + warning + versionPreviewHTML(currentVersion), null, function(status) {
            if (status) {
                $scope.state.loading = true;
                api.undoPostVersion({postId: $scope.state.postId, versionId: currentVersion.id, pageId: currentVersion.pageId}).then(function(res) {
                    if (res?.data?.success) {
                        $scope.waitUntilReady(function(result) {
                            $scope.state.loading = false;
                            if (!result.success) {
                                showError(gettext('error.generic'))
                            }
                        });
                    } else {
                        $scope.state.loading = false;
                        showError(gettext('error.generic'))
                    }
                }).catch(function(error) {
                    console.error('Error undoing version:', error);
                    $scope.state.loading = false;
                    showError(gettext('error.generic'))
                })
            }
        })
    }
});